<template>
  <a-drawer
    :title="title"
    :width="width"
    placement="right"
    :closable="false"
    @close="close"
    :visible="visible">
  
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="入口" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-popup
            v-decorator="['tableBoardType', validatorRules.tableBoardType]"
            :trigger-change="true"
            org-fields="tableBoardType,jpStoneType,jpStoneSeries,jpFlowerColor"
            dest-fields="table_board_type,jp_stone_type,jp_stone_series,jp_flower_color"
            code="gold_stone_info"
            @callback="popupCallback"/>
        </a-form-item>
        <a-form-item label="产品" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'jpStoneType', validatorRules.jpStoneType]" placeholder="请输入产品"></a-input>
        </a-form-item>
        <a-form-item label="系列" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'jpStoneSeries', validatorRules.jpStoneSeries]" placeholder="请输入系列"></a-input>
        </a-form-item>
        <a-form-item label="花色" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'jpFlowerColor', validatorRules.jpFlowerColor]" placeholder="请输入花色"></a-input>
        </a-form-item>
        <a-form-item label="是否新品" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['newProduct', validatorRules.newProduct]" :trigger-change="true" dictCode="is_not_new_product" placeholder="请选择是否新品"/>
        </a-form-item>
        <a-form-item label="国产/进口" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['madeFrom', validatorRules.madeFrom]" :trigger-change="true" dictCode="is_made_from" placeholder="请选择国产/进口"/>
        </a-form-item>
        <a-form-item label="介绍" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'introduce', validatorRules.introduce]" placeholder="请输入介绍"></a-input>
        </a-form-item>
        <a-form-item label="主图路径" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-upload v-decorator="['jpStoneMainddress', validatorRules.jpStoneMainddress]" :trigger-change="true"></j-upload>
        </a-form-item>
        <a-form-item label="详情图路径" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-upload v-decorator="['jpStoneDetailaddress', validatorRules.jpStoneDetailaddress]" :trigger-change="true"></j-upload>
        </a-form-item>
        <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea v-decorator="['remarks', validatorRules.remarks]" rows="4" placeholder="请输入备注"/>
        </a-form-item>
        
      </a-form>
    </a-spin>
    <a-button type="primary" @click="handleOk">确定</a-button>
    <a-button type="primary" @click="handleCancel">取消</a-button>
  </a-drawer>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JUpload from '@/components/jeecg/JUpload'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  
  export default {
    name: "GoldStoneJpglistModal",
    components: { 
      JUpload,
      JDictSelectTag,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          tableBoardType: {rules: [
            {required: true, message: '请输入入口!'},
          ]},
          jpStoneType: {rules: [
          ]},
          jpStoneSeries: {rules: [
          ]},
          jpFlowerColor: {rules: [
          ]},
          newProduct: {rules: [
          ]},
          madeFrom: {rules: [
          ]},
          introduce: {rules: [
          ]},
          jpStoneMainddress: {rules: [
          ]},
          jpStoneDetailaddress: {rules: [
          ]},
          remarks: {rules: [
          ]},
        },
        url: {
          add: "/goldenstone.base/goldStoneJpglist/add",
          edit: "/goldenstone.base/goldStoneJpglist/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'updateTime','tableBoardType','jpStoneType','jpStoneSeries','jpFlowerColor','newProduct','madeFrom','introduce','jpStoneMainddress','jpStoneDetailaddress','remarks'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'updateTime','tableBoardType','jpStoneType','jpStoneSeries','jpFlowerColor','newProduct','madeFrom','introduce','jpStoneMainddress','jpStoneDetailaddress','remarks'))
      }
      
    }
  }
</script>

<style lang="less" scoped>
/** Button按钮间距 */
  .ant-btn {
    margin-left: 30px;
    margin-bottom: 30px;
    float: right;
  }
</style>